import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "FolderDetails"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M3 19.5H10.5V21H3C2.17157 21 1.5 20.3284 1.5 19.5V4.5C1.5 3.67157 2.17157 3 3 3H8.3775C8.77728 2.99968 9.16065 3.15897 9.4425 3.4425L12 6H21C21.8284 6 22.5 6.67157 22.5 7.5V13.5H21V7.5H11.3775L10.9425 7.0575L8.3775 4.5H3V19.5ZM22.5 15H12V16.5H22.5V15ZM12 18H22.5V19.5H12V18ZM17.25 21H12V22.5H17.25V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/FolderDetails.vue"]]);
